//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { IntelligentProductTaggingLinkRequestV2 } from '@apis/intelligent-product-tagging/intelligentProductTaggingApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const intelligentProductTaggingFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch('ipt_gateway', `/api/v2/ipt${endpoint}`, init);
};

/**
 * Records that a client linked a product to a bounding box (v2)
 *
 * POST /api/v2/ipt/link
 */
export const linkProductToBoundingBoxV2 = async (
  req: IntelligentProductTaggingLinkRequestV2,
  init?: RequestInit,
): Promise<void> => {
  await intelligentProductTaggingFetch(`/link`, {
    ...(init ?? {}),
    body: JSON.stringify(req),
    method: 'POST',
  });
};
